module.exports = "<div *ngIf=\"logs\" class=\"col-xs-4\">\r\n    <h3>\r\n        Logs\r\n    </h3>\r\n    <app-table-template *ngIf=\"logs && columns\" [data]=\"logs\" [columns]=\"columns\"></app-table-template><br>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/log/log.list.component.html
// module id = 259
// module chunks = 1